import { palette } from './palette'

export const color = {
  blue: '#225FF6',
  black: '#000000',
  white: '#ffffff',
  background: '#F7F7FB',
  grey: '#F6F8FB',
  clearGrey: '#737373',
  lightGrey: '#DADADA',
  darkGrey: '#444444',
  darkenGrey: '#737373',
  orange: '#FBA928',
  darkOrange: '#fb9c5b',
  purple: '#551BFA',
  green: '#1FE08F',
  red: '#FF3E13',
  yellow: '#FFCE51',
  blueGrey: '#F3F5FB',
  greyBlue: '#E4EBFF',
  bluePurple: '#ECE9FF',
  darkProgressBg: 'rgba(127,127,127,.5)',
  bronze: '#A59E8E',
  silver: '#778390',
  gold: '#EDB552',
  transparent: 'rgba(0, 0, 0, 0)',
  opaque: 'rgba(255, 255, 255, 0.5)',
  modalBackground: '#151E2360',
  offWhite: '#f7f7f7',
  athensGrey: '#F0F2F5',
  quizBackground: palette.charcoal,
  quizCorrectAnswer: '#00CB76',
  quizInCorrectAnswer: '#ED3939',
  blueDisabled: 'rgb(34,95,246, 0.4)',

  /**
   * A transparent shade to darken the color behind an element
   */
  shade04: 'rgba(0, 0, 0, 0.04)',
  shade10: 'rgba(0, 0, 0, 0.1)',
  shade20: 'rgba(0, 0, 0, 0.2)',
  shade30: 'rgba(0, 0, 0, 0.3)',
  shade40: 'rgba(0, 0, 0, 0.4)',
  shade50: 'rgba(0, 0, 0, 0.5)',
  shade70: 'rgba(0, 0, 0, 0.7)',

  /**
   * A transparent shade to whiten the color behind an element
   */
  tint10: 'rgba(255, 255, 255, 0.1)',
  tint20: 'rgba(255, 255, 255, 0.2)',
  tint70: 'rgba(255, 255, 255, 0.7)',

  /**
   * A subtle color used for borders and lines.
   */
  border: '#EDEFF1',
  backgroundGrey: 'rgb(240,240,243)',

  palette,
}

export type ColorType = keyof typeof color
